import useDropdownOptions from "~/hooks/useDropdownOptions";

const useDocumentCategories = () =>
  useDropdownOptions("/documents/categories");

export default useDocumentCategories;
